import React from 'react';
import styles from './ButtonBuy.module.scss';

const ButtonBuy = ({ product, addToOrder, children, type, isOffline, disabled }) => {
  console.log(type);

  if (type !== null) {
    return (
      <a href={type} className={styles.productButton} rel="noopener noreferrer" target="_blank">
        Купить
      </a>
    );
  }
  if (type === null) {
    return (
      !isOffline && (
        <button className={styles.productButton} disabled={disabled} onClick={() => addToOrder(product)}>
          {children}
        </button>
      )
    );
  }
};

export default ButtonBuy;
